import { useEffect, useState } from 'react';
import moment from 'moment-timezone';
import { isBodRiskWindow } from './bodWindow';

const TZ = 'America/New_York';

/**
 * Next ET instant when the BoD risk window opens or closes.
 * @param {moment.Moment} [now]
 * @returns {moment.Moment}
 */
export function nextBodBoundary(now = moment.tz(TZ)) {
  const start = now.clone().startOf('day').add(90, 'minutes'); // 01:30
  const end = now.clone().startOf('day').add(210, 'minutes'); // 03:30
  if (now.isBefore(start)) {
    return start;
  }
  if (now.isBefore(end)) {
    return end;
  }
  return now
    .clone()
    .startOf('day')
    .add(1, 'day')
    .add(90, 'minutes');
}

/**
 * Live BoD risk-window flag that re-renders at window boundaries (and every
 * minute as a fallback) so banners do not go stale on long-lived pages.
 */
export function useBodRiskWindow() {
  const [inWindow, setInWindow] = useState(() => isBodRiskWindow());

  useEffect(() => {
    let timeoutId;
    let intervalId;

    const refresh = () => {
      setInWindow(isBodRiskWindow());
    };

    const scheduleBoundary = () => {
      const delay = Math.max(
        nextBodBoundary().diff(moment.tz(TZ)),
        1000
      );
      timeoutId = setTimeout(() => {
        refresh();
        scheduleBoundary();
      }, delay);
    };

    refresh();
    scheduleBoundary();
    // Fallback if the tab slept through a boundary timeout.
    intervalId = setInterval(refresh, 60 * 1000);

    return () => {
      clearTimeout(timeoutId);
      clearInterval(intervalId);
    };
  }, []);

  return inWindow;
}
